module.exports = "<c-select name=\"{{$ctrl.name}}\"\n  label=\"{{$ctrl.label}}\"\n  ng-model=\"$ctrl.ngModel\"\n  options=\"$ctrl.items\"\n  key-value=\"{{ !$ctrl.selectModel? 'codigo' : '' }}\"\n  ng-disabled=\"$ctrl.ngDisabled\"\n  ng-required=\"$ctrl.ngRequired\">\n</c-select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/core/util/forms/selectParametro/selectParametro.html
// module id = 588
// module chunks = 0